import { useEffect } from 'react';

import { PdfViewerLoadable } from '#/components/PdfViewer/PdfViewerLoadable';
import { useSetDocumentTitle } from '#/hooks/useSetDocumentTitle';
import { useI18n } from '#/i18n/hooks/useI18n';
import { LayoutFullWidthBody } from '#/layouts/Layout/LayoutFullWidthBody';
import { trackPageView } from '#/utils/analytics/track/trackPageView';

type Props = {
  filename: string;
};

export function ViewPdfFilePage({ filename }: Props) {
  const { i18n } = useI18n();
  useEffect(() => {
    trackPageView('Pdf Viewer', {
      url: `/files/${filename}`,
      filename,
    });
  }, [filename]);

  useSetDocumentTitle(i18n('Documents'));

  const files = [
    {
      url: `/files/${filename}?download=true`,
      downloadUrl: `/files/${filename}?download=true`,
      label: filename,
      id: filename,
    },
  ];

  return (
    <LayoutFullWidthBody $centered>
      <PdfViewerLoadable files={files} shareUrl={`/files/${filename}`} />
    </LayoutFullWidthBody>
  );
}
